"use client";

import { useRouter, useSearchParams } from "next/navigation";
import { useEffect, useState } from "react";

import type { PropsWithChildren } from "react";

export function EnforcePageParam({
  children,
  stepCount,
}: PropsWithChildren<{
  stepCount: number;
}>) {
  const router = useRouter();
  const searchParams = useSearchParams();
  const [hasPageQP, setHasPageQP] = useState(false);

  useEffect(
    function () {
      const urlParams = new URLSearchParams(window.location.search);
      const page = parseInt(urlParams.get("page") ?? "");

      const failure = function () {
        setHasPageQP(false);
        const params = new URLSearchParams(searchParams.toString());
        params.set("page", "1");
        router.replace(`?${params.toString()}`);
      };

      if (!page || Number.isNaN(page)) {
        failure();
        return;
      }

      if (page > stepCount) {
        failure();
        return;
      }

      setHasPageQP(true);
    },
    [router, searchParams, stepCount],
  );

  return hasPageQP ? children : null;
}
